export const MAXIMUM_HIGHSCORE_LENGTH = 6;
